import { render, staticRenderFns } from "./BaiduTargetingAdd.vue?vue&type=template&id=1c054856&scoped=true"
import script from "./BaiduTargetingAdd.vue?vue&type=script&lang=js"
export * from "./BaiduTargetingAdd.vue?vue&type=script&lang=js"
import style0 from "./BaiduTargetingAdd.vue?vue&type=style&index=0&id=1c054856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c054856",
  null
  
)

export default component.exports